export const nextPosition = (items) =>
  Math.max(-1, ...items.map((item) => item.position)) + 1;

export function reorderItems(items, source, destination) {
  if (!destination || source.index === destination.index) return null;
  const reordered = [...items];
  const [moved] = reordered.splice(source.index, 1);
  reordered.splice(destination.index, 0, moved);
  return reordered.map((item, position) => ({ ...item, position }));
}
